import getImagePath from "@Utils/getImagePath";
import styles from "./roomFeaturedImages.module.scss";
import Image from "@Components/Image";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { PAGE } from "constants/configConstants";
import PropertyPageDispatcher from "@Pages/PropertyPage/data/actions";
import { useDispatch } from "react-redux";
import Carousel from "@Components/Carousel";
import CarouselIndicator from "@Components/Carousel/components/CarouselIndicator";
import { useState } from "react";
import ImagePaginationBox from "@Components/ImagePagination/ImagePagination";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import ThreeDIcon from "@Icons/ThreeDIcon";
import wrapperHOC from "@Utils/wrapperHOC";
import PhotosIcon from "@Icons/PhotosIcon";

type RoomFeaturedImagesProps = {
  images: any;
  assetsLength: any;
  isDesktop?: boolean;
  virtualView?: any;
};

const RoomFeaturedImages = ({
  images,
  assetsLength,
  isDesktop = false,
  virtualView,
}: RoomFeaturedImagesProps) => {
  const dispatch = useDispatch();
  const propertyPageDispatcher = new PropertyPageDispatcher(dispatch);
  const IMAGES_TO_SHOW = 3;
  const media = [...virtualView, ...images];
  const showOverlay = assetsLength > media.length || media.length > IMAGES_TO_SHOW;
  const showOverlayIndex = media.length < IMAGES_TO_SHOW ? media.length - 1 : IMAGES_TO_SHOW - 1;
  const remainingAssetCount =
    showOverlay && media.length > IMAGES_TO_SHOW
      ? assetsLength - IMAGES_TO_SHOW
      : assetsLength - media.length;

  const handleImageClick = (index: number) => {
    propertyPageDispatcher.showGalleryCarousel({
      show: true,
      images: media,
      category: "room-type",
      currentItemIndex: index,
      showViewRoomButton: false,
    });
    gtagEventEmitter({
      action: "room_photo_viewed",
      category: PAGE.INVENTORY,
      label: "view_more_details",
    });
  };

  const [activePos, setActivePos] = useState(1);
  const handleChangeSlide = (pos: number) => {
    setActivePos(pos);
    gtagEventEmitter({
      action: "room_photo_scrolled",
      category: PAGE.INVENTORY,
      label: "view_more_details",
    });
  };

  return (
    <div className={formatClassNames(styles.imagesContainer, isDesktop && styles.desktop)}>
      {isDesktop ? (
        media.slice(0, IMAGES_TO_SHOW).map((img: any, index: number) => (
          <div
            className={styles.imageWrapper}
            key={`${img.path}-${index}`}
            role="button"
            tabIndex={0}
            onKeyDown={() => handleImageClick(index)}
            onClick={() => handleImageClick(index)}
          >
            <Image
              className={styles.image}
              src={getImagePath(img.path || images[index]?.path, "room-type-card")}
              height="100%"
              width="100%"
              dataTestId="propertry-room-type-view-more-details-images"
            />
            {img?.category === "3D" && (
              <div className={styles.overlay}>
                <ThreeDIcon />
              </div>
            )}
            {showOverlay && index === showOverlayIndex && (
              // <div className={styles.overlay}>
              //   <span color="white" className={styles.overlayText}>
              //     +{remainingAssetCount}
              //   </span>
              // </div>
              <div className={styles.imageCount}>
                <PhotosIcon width="12px" height="12px" fill="white" />
                {remainingAssetCount}
              </div>
            )}
          </div>
        ))
      ) : (
        <>
          <Carousel
            className={styles.container}
            slideList={media.map((img: any, slideIndex: any) => (
              <div onClick={() => handleImageClick(slideIndex)} role="none">
                <Image
                  isEagerLoad={slideIndex === 0}
                  src={getImagePath(img.path || images[slideIndex]?.path, "room-type-card")}
                  width="100%"
                  height="264px"
                />
                {img?.category === "3D" && (
                  <div className={styles.overlay}>
                    <ThreeDIcon />
                  </div>
                )}
              </div>
            ))}
            activePos={activePos}
            handleChangeSlide={handleChangeSlide}
          />
          {media.length > 1 && (
            <>
              <CarouselIndicator
                activeDot={activePos}
                totalSlider={media.length}
                handleClickIndicator={handleChangeSlide}
                indicatorWrapperClassName={styles.indicator}
                type="line"
                dotColor="white"
                addInfinite
              />
              <div className={styles.paginationContainer}>
                <ImagePaginationBox totalNumber={media?.length} currentIndex={activePos} />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default wrapperHOC(RoomFeaturedImages, {
  componentName: "RoomFeaturedImages-ViewMoreDetailsModal-RoomTypeCard-PropertyPage",
  showForChina: true,
});
